// extracted by mini-css-extract-plugin
export default {"isDesktop":"IsDesktop-module--isDesktop--5c46b"};